<template lang="pug">
  include /mixins
  div
    //- product-sale-view(
    //-   v-bind='productProps'
    //-   v-on='productListeners'
    //- )
    product-base-view(
      v-bind='productProps'
      v-on='productListeners'
      :is-cart-modal="isCartModal"
    )

</template>
<script>
import ProductBaseView from './Variants/Base'
import ProductSaleView from './Variants/Sale'

export default {
  name: 'ProductUi',
  components: {
    ProductBaseView,
    ProductSaleView,
  },
  props: {
    product: {
      default: () => { },
    },
    load: {},
    isCartModal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    productListeners() {
      return {
        ...this.$listeners,
        removeFromCart: () => this.$emit('removeFromCart'),
        updateCart: event => this.$emit('updateCart', event),
      }
    },
    productProps() {
      const { relations, base, price, id } = this.product
      return {
        load: this.load,
        product: base,
        group_id: id,
        relations,
        price,
        disabled: this.$attrs.disabled,
      }
    },
  },
}
</script>
